import * as React from "react";

export const renderLeague = (showLeagueInEventCard: boolean, leagueName: string) =>
    showLeagueInEventCard &&
        <div className="rj-ev-list__ev-card__section-item rj-ev-list__ev-card__league" data-uat="div-ev-list-ev-card-league">
            <span className="rj-ev-list__name-text" data-uat="span-ev-list-name-text">{leagueName}</span>
        </div>